import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SellerView = () => {
  const { id } = useParams(); // seller_id
  const navigate = useNavigate();

  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      toast.error("Seller ID missing");
      setLoading(false);
      return;
    }

    fetchSellerData();
  }, [id]);

  const fetchSellerData = async () => {
    try {
      const formData = new FormData();
      formData.append("seller_id", id);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_seller_registration",
        formData
      );

      console.log("Fetch Seller Response:", response.data);

      if (response.data.status === true) {
        setSeller(response.data.data);
      } else {
        toast.error(response.data.message || "Seller not found");
      }
    } catch (error) {
      console.error("Error fetching seller:", error);
      toast.error("Failed to fetch seller details");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center mt-5">
          <h5>Loading...</h5>
        </div>
      </div>
    );
  }

  if (!seller) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center mt-5">
          <h5>No seller data found</h5>
          <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Seller View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript:void(0);">Seller</Link>
                </li>
                <li className="breadcrumb-item active">Seller View</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Seller Card */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card coupan-view p-3">
              <div className="cross-icon">
                <Link to="/Seller-registration-list">
                  <i className="fa-solid fa-circle-xmark"></i>
                </Link>
              </div>

              <strong>Seller ID</strong>
              <p>{seller.seller_id}</p>

              <strong>Business Name</strong>
              <p>{seller.business_name}</p>

              <strong>Business Type</strong>
              <p>{seller.business_type}</p>

              <strong>Brand Name</strong>
              <p>{seller.brand_name}</p>

              <strong>Owner Name</strong>
              <p>{seller.owner_name}</p>

              <strong>Email</strong>
              <p>{seller.email}</p>

              <strong>Mobile</strong>
              <p>{seller.mobile}</p>

              <strong>GST Number</strong>
              <p>{seller.gst_number}</p>

              <strong>PAN Number</strong>
              <p>{seller.pan_number}</p>

              <strong>Address</strong>
              <p>{seller.address}</p>

              <strong>City</strong>
              <p>{seller.city}</p>

              <strong>State</strong>
              <p>{seller.state}</p>

              <strong>Pincode</strong>
              <p>{seller.pincode}</p>

              <strong>Status</strong>
              <p>{seller.status}</p>

              <hr />

              <strong>GST Document</strong>
              <p>
                {seller.gst_document ? (
                  <a
                    href={`https://cyberathon.com/multivendor/${seller.gst_document}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View
                  </a>
                ) : (
                  "-"
                )}
              </p>

              <strong>Cancelled Cheque</strong>
              <p>
                {seller.cancel_cheque_document ? (
                  <a
                    href={`https://cyberathon.com/multivendor/${seller.cancel_cheque_document}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View
                  </a>
                ) : (
                  "-"
                )}
              </p>

              <strong>Trademark Certificate</strong>
              <p>
                {seller.trademark_certificate ? (
                  <a
                    href={`https://cyberathon.com/multivendor/${seller.trademark_certificate}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View
                  </a>
                ) : (
                  "-"
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SellerView;
